import { Flex, IconButton, Text } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import { WhitespaceText, useGlyphColor, useQuoteStyle } from '../whitespace';

interface ValueEntryProps<T> {
  value: T;
  onEdit: (v: T) => void;
  onDelete: (v: T) => void;
}

function MultiValueItemV3<T extends React.ReactNode>({
  value,
  onEdit,
  onDelete,
}: ValueEntryProps<T>) {
  const {
    palette: { tokens },
  } = useTheme();
  const quoteSx = useQuoteStyle();
  const glyphColor = useGlyphColor();
  const isString = typeof value === 'string';
  return (
    <Flex
      borderBottom={`1px solid ${tokens.stroke.neutral[5]}`}
      align="center"
      justify="space-between"
      py={2}
      pl={4}
    >
      <Flex align="baseline" gap="2px" data-testid="entry-value" minWidth={0}>
        {isString ? (
          <>
            <Text as="span" sx={quoteSx} aria-hidden="true">
              &ldquo;
            </Text>
            <Text as="span" variant="body/sm" fontWeight="medium" truncated>
              <WhitespaceText value={value as string} glyphColor={glyphColor} />
            </Text>
            <Text as="span" sx={quoteSx} aria-hidden="true">
              &rdquo;
            </Text>
          </>
        ) : (
          <Text as="span" variant="body/sm" fontWeight="medium" truncated>
            {value}
          </Text>
        )}
      </Flex>
      <Flex gap={2}>
        <IconButton
          aria-label={`Edit entry ${value}`}
          icon="edit"
          size="medium"
          variant="outline"
          onClick={() => onEdit(value)}
        />
        <IconButton
          aria-label={`Delete entry ${value}`}
          icon="trash"
          size="medium"
          variant="outline"
          onClick={() => onDelete(value)}
        />
      </Flex>
    </Flex>
  );
}

export default MultiValueItemV3;
